import { Fragment } from "react";
import { Icons } from "../../../utils/icons";
import { Tooltip } from "flowbite-react";
import DefaultButton from "../buttons/defaultButton";

  const iconMap = {
    view: Icons.VIEW,
    edit: Icons.EDIT,
    add: Icons.ADD,
    delete: Icons.DELETE,
    assign: Icons.ASSIGN,
    download: Icons.DOWNLOAD,
    import: Icons.IMPORT,
    export: Icons.EXPORT,
    print: Icons.PRINT,
    settings: Icons.SETTINGS,
    archive: Icons.ARCHIVE,
    unarchive: Icons.UNARCHIVE,
    approve: Icons.APPROVE,
    reject: Icons.REJECT,
    share: Icons.SHARE,
    duplicate: Icons.DUPLICATE,
    more: Icons.MORE,
    close: Icons.CLOSE,
    search: Icons.SEARCH,
    filter: Icons.FILTER,
    clear:Icons.CLEAR,
    expire:Icons.EXPIRE,
    active:Icons.ACTIVE,
    inactive:Icons.INACTIVE,
    onhold:Icons.ONHOLD,
    cancel:Icons.CANCEL,
    publish:Icons.PUBLISH,
    reopen:Icons.REOPEN,
  };

export const IconActionButton = ({ actions = []}) => {

  return (
    <div className="flex items-center gap-0.5">
      {actions.map(({ name, link, onClick = () => {}, icon = null }, index) => {
        const Icon = icon || iconMap[name];
        if (!Icon) return null;

        const isLast = index === actions.length - 1;

        const ActionElement = link ? (
          <a
            href={link}
            className="w-8 h-8 flexCenter text-lg cursor-pointer text-gray-500 hover:text-primary-600 transition-colors rounded-md hover:bg-primary-50"
            aria-label={name}
          >
            {Icon && typeof Icon === "function" ? <Icon /> : Icon}
          </a>
        ) : (
          <DefaultButton
            onClick={onClick}
            className="w-8 h-8 flexCenter text-lg cursor-pointer text-gray-500 hover:text-primary-600 transition-colors rounded-md hover:bg-primary-50"
            aria-label={name}
            icon={Icon}
          />
        );

        return (
          <Fragment key={index}>
            <Tooltip
              content={name}
              className="text-xs shadow-md !capitalize"
              placement="top"
              animation="duration-300"
            >
              <div className="flex items-center group">{ActionElement}</div>
            </Tooltip>
            {!isLast && <div className="w-[1px] h-4 bg-gray-200 mx-0.5" />}
          </Fragment>
        );
      })}
    </div>
  );
};
